import { css } from '@emotion/core';
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import Icon from '@veeva/corgix/icon';

function EmailSuccess({ newEmail, labels }) {
    return (
        <div
            css={({ green }) => {
                return css`
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    gap: 1.667rem;
                    text-align: center;

                    svg[data-icon='check-circle'] {
                        width: 8.333rem;
                        height: 8.333rem;
                        color: ${green};
                    }
                `;
            }}
        >
            <div
                css={css`
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    font-weight: bold;
                `}
            >
                <span>{labels.confirmationSentLabel}</span>
                <span>{newEmail}</span>
            </div>
            <Icon type={faCheckCircle} />
            {labels.confirmationSentInstructionLabel}
        </div>
    );
}

export default EmailSuccess;
